import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_FilterItem = _resolveComponent("FilterItem")!
  const _component_PageHeaderFilters = _resolveComponent("PageHeaderFilters")!
  const _component_NguoiDungTable = _resolveComponent("NguoiDungTable")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!

  return (_openBlock(), _createBlock(_component_PageContentBase, null, {
    default: _withCtx(() => [
      _createVNode(_component_PageHeaderFilters, null, {
        default: _withCtx(() => [
          _createVNode(_component_FilterItem, { label: "Đơn vị" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.selectedDonViId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDonViId) = $event)),
                class: "min-w-[12rem]",
                disabled: _ctx.isUnitLevel,
                filterable: "",
                placeholder: "Chọn đơn vị"
              }, {
                default: _withCtx(() => [
                  (_ctx.isCompanyLevel)
                    ? (_openBlock(), _createBlock(_component_el_option, {
                        key: 0,
                        label: "Tất cả",
                        value: ''
                      }))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.donViOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.ten_don_vi,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_NguoiDungTable, {
        "cur-page": _ctx.currentPage,
        items: _ctx.nguoiDungItems,
        "is-loading": _ctx.loading,
        "per-page": _ctx.perPage,
        onRefresh: _ctx.fetchData
      }, null, 8, ["cur-page", "items", "is-loading", "per-page", "onRefresh"]),
      (_ctx.totalItems > 0)
        ? (_openBlock(), _createBlock(_component_Pagination, {
            key: 0,
            page: _ctx.currentPage,
            "page-size": _ctx.perPage,
            total: _ctx.totalItems,
            onChangePage: _cache[1] || (_cache[1] = (value) => (_ctx.currentPage = value)),
            onChangePageSize: _cache[2] || (_cache[2] = (value) => (_ctx.perPage = value))
          }, null, 8, ["page", "page-size", "total"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}